import { useQuery } from "@tanstack/react-query";
import { debtAPI } from "../debtAPI.ts";

export const useGetDebtStateQuery = () => {
  return useQuery ({
    queryKey: ["debt-state"],
    queryFn: () => debtAPI.getDebtState(),
    staleTime: 15 * 60 * 1000, // 15мин
    gcTime: 60 * 60 * 1000, // 60мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
